import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";
import {ConditionsProps} from "../utils/segmentBuilder";

export interface CreateSegmentRequest {
    domain: string;
    title: string;
    description: string;
    conditions: ConditionsProps[];
}


export const createSegment = async ({ domain, title, description, conditions }: CreateSegmentRequest): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `segment`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            domain,
            title,
            description,
            conditions
        },
        domain,
        isEncrypted: true,
    });
}